import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import React from 'react';

// Define a consistent color palette for chart lines
export const LINE_COLORS = [
  '#0891b2', // Your primary color
  '#1e88e5', // Blue
  '#ff9800', // Orange
  '#d32f2f', // Red
  '#9c27b0', // Purple
  '#4caf50', // Green (for more than 5, though limit is 5)
];

// Color for the total line
export const TOTAL_LINE_COLOR = '#525252'; // A neutral grey color

// Define fill opacity for the areas
export const AREA_FILL_OPACITY = 0.1; // 10% transparency

export const MAX_CHART_LINES = 5;

const DynamicChart = ({
  reportConfig,
  chartData,
  selectedItems,
  totalDataForSelectedItems,
}) => {
  return (
    <ResponsiveContainer width='100%' height={300}>
      <AreaChart data={chartData}>
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis dataKey='date' />
        <YAxis />
        <Tooltip />
        <Legend />
        {/* Add the total data line for selected items */}
        {totalDataForSelectedItems.length > 0 && (
          <Area
            type='monotone'
            dataKey={`Total ${reportConfig.timeSeriesMetric}`}
            stroke={TOTAL_LINE_COLOR}
            fill={TOTAL_LINE_COLOR}
            fillOpacity={AREA_FILL_OPACITY}
            strokeDasharray='3 3'
            activeDot={{ r: 8 }}
            name={`Total ${
              reportConfig.timeSeriesMetric === 'screenPageViews'
                ? 'Views'
                : 'Events'
            } (Selected)`}
          />
        )}
        {selectedItems.map((item, index) => (
          <Area
            key={item.name}
            type='monotone'
            dataKey={item.name}
            stroke={LINE_COLORS[index % LINE_COLORS.length]}
            fill={LINE_COLORS[index % LINE_COLORS.length]}
            fillOpacity={AREA_FILL_OPACITY}
            activeDot={{ r: 8 }}
            name={item.name}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default DynamicChart;
